<template>
  <div v-parallax-fit="parallax" class="key">
    <img src="/themes/rise-theme/dist/images/estate/character-view/holly/08_Keys.png" alt="">
  </div>
</template>

<script>
export default {
  data() {
    return {
      mutationObserver: null,
      parallax: [
        {
          start: 2000,
          end: 2950,
          fromStyle: { transform: 'translateX(100%) translateY(-100%)', marginTop: '10px' },
          toStyle: { transform: 'translateX(-20%) translateY(-20%)', marginTop: '0px' },
          easing: 'linear'
        },
        {
          start: 3200,
          end: 3900,
          fromStyle: { transform: 'translateX(-20%) translateY(-20%)', marginTop: '0px' },
          toStyle: { transform: 'translateX(-65%) translateY(21%)', marginTop: '10px' },
          easing: 'linear'
        },
        {
          start: 4300,
          end: 5500,
          fromStyle: { transform: 'translateX(-65%) translateY(21%)' },
          toStyle: { transform: 'translateX(-150%) translateY(350%)' },
          easing: 'linear'
        }
      ]
    }
  },
  mounted() {
    const self = this;
    const evidence = {
      items: [
        {
          image: '/themes/rise-theme/dist/images/estate/character-view/holly/evidence/4.png',
          url: 'https://www.manufacturedhomelivingnews.com/wp-content/uploads/2019/12/Private-Equity-Giants-Converge-on-Manufactured-Homes-PrivateEquityStakeholderProject-MHAction-AFR-021419ManufacturedHomeLivingNews.pdf',
          link_title: {
			'en': "Private Equity Giants Converge on Manufactured Homes",
			'es': 'Gigantes de capital privado convergen en casas prefabricadas'
		  },
        }
      ],
      text: {
		'en': "Manufactured homes also can have complicated ownership structure. In mobile home parks, people may rent the lot, but own their own home; outside of parks, they are more likely to own both the home and the land it sits on.",
		'es': 'Las casas prefabricadas también pueden tener una estructura de propiedad complicada. En los parques de casas móviles, las personas pueden alquilar el lote, pero ser dueños de su propia casa; fuera de los parques, es más probable que sean dueños tanto de la casa como del terreno en el que se asienta.'
	  }
    };
    const text = {
		'en': "Manufactured home communities are one of the last sectors of affordable housing in the United States. Across the country, they are home to seniors on fixed incomes, low-income families, immigrants, people with disabilities, veterans, and others in need of low-cost housing.",
		'es': 'Las comunidades de casas prefabricadas son uno de los últimos sectores de viviendas asequibles en los Estados Unidos. En todo el país, son el hogar de personas mayores con ingresos fijos, familias de bajos ingresos, inmigrantes, personas con discapacidades, veteranos y otras personas que necesitan viviendas de bajo costo.'
	};

    this.mutationObserver = new window.MutationObserver(mutationList => {
      mutationList.forEach(mutation => {
        if (mutation.target.style.marginTop == '0px') {
          self.$evidence.value = JSON.stringify(evidence);
          self.$readMore.value = text;
        }
      });
    });

    this.mutationObserver.observe(document.querySelector('.key'), {
      attributes: true,
      attributeFilter: ['style']
    });
  },
  unmounted() {
    this.mutationObserver.disconnect();
  }
}
</script>

<style lang="scss" scoped>
.key {
  position: fixed;
  top: 0%;
  right: 0%;
  z-index: 2;
  max-width: 600px;
  transition: all 0.1s linear;
}

@media screen and (max-width: 1600px) {
  .key {
    max-width: 400px;
  }
}

@media screen and (max-width: 1024px) {
  .key {
    max-width: 300px;
  }
}

@media screen and (max-width: 650px) {
  .key {
    max-width: 200px;
  }
}
</style>
